import { TYPES } from '@model/utils/types';
import { Type } from './Type';

export class Int extends Type {
    static getDefault() {
        return 0;
    }

    static toValue(value: any, radix = 10): number | null {
        if (typeof value === 'boolean') {
            return value ? 1 : 0;
        }

        if (!value) {
            return 0;
        }

        return parseInt(value, radix);
    }
}

Int[TYPES.TYPE] = 'int';
